/* import __COLOCATED_TEMPLATE__ from './apply-conversation-sla.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();